import React from "react";
import { Routes, Route } from "react-router-dom";
import MaintenanceMode from "../component/MaintenanceMode";
// Importing all your components
import Home from "../Homepage/Home";
import Frontpage from "../component/Frontpage";
import Experience from "../component/oursolutions/Experience";
import About from "../component/about/About";
import TheValue from "../component/valueadded/TheValue";
import Journey from "../component/journey/Journey";
import Resource from "../component/Resource";
import ContactUs from "../component/contact/ContactUs";
import HomePage from "../component/HomePage";
import Runwal from "../component/runwalTours/Runwal";
import RunnwalRoute from "../component/runwalTours/RunnwalRoute";
import Customizer from "../component/Customizer";
import PrivacyPolicy from "../component/privacypolicy/PrivacyPolicy";
import TermsOfUse from "../component/termsofuse/TermsOfUse";
import Disclaimer from "../component/disclaimer/Disclaimer";
import AthlonPage from "../component/athlon/Athlon";
import AldarPage from "../component/aldar/Aldar";
import AldaramPage from "../component/aldaram/Aldaram";
import EmaarPage from "../component/emaar/Emaar";
// Component to redirect to /convrse-spaces
// const RedirectHome = () => {
//   const navigate = useNavigate();
//   // const { setHostName } = useSelectedTitleContext();
//   useEffect(() => {
//     navigate("/convrse-spaces");
//   }, [navigate]);
//   return null;
// };
const AppRou = () => (
  <Routes>
    {/* Initial Redirect */}
    {/* Removed <Navigate to="/convrse-spaces" />  */}
    {/* Main Routes (commented for maintenance mode) */}
    <Route path="/" element={<HomePage />} />
    <Route path="/home" element={<HomePage />} />
    <Route path="/about" element={<About />} />
    <Route path="/the-value-added-suite" element={<TheValue />} />
    <Route path="/the-journey" element={<Journey />} />
    <Route path="/contact-us" element={<ContactUs />} />
    <Route path="/resources" element={<Resource />} />
    <Route path="/our-solutions" element={<Experience />} />
    <Route path="/runwal-tours" element={<RunnwalRoute />} />
    <Route path="/customizer" element={<Customizer />} />
    <Route path="/privacypolicy" element={<PrivacyPolicy />} />
    <Route path="/terms" element={<TermsOfUse />} />
    <Route path="/disclaimer" element={<Disclaimer />} />
    <Route path="/athlon" element={<AthlonPage />} />
    <Route path="/aldar" element={<AldarPage />} />
    <Route path="/aldaram" element={<AldaramPage />} />
    <Route path="/emaar" element={<EmaarPage />} />
    {/* <Route path="*" element={<MaintenanceMode />} /> */}
  </Routes>
);
export default AppRou;







